import styled from 'styled-components'
import { Drawer, IconButton } from '@mui/material'
import { GGBLogoDarkWithoutBg } from 'assets/images'
import { ChevronRightIcon } from 'assets/icons/chevron-right'
import { ChevronLeftIcon } from 'assets/icons/chevron-left'

import AppDrawerItems from './AppDrawerItems'

interface Props {
  open: boolean
  toggle?: () => void
}

export default function AppDrawer({ open, toggle }: Props): JSX.Element {
  return (
    <StyledDrawer variant="permanent" open={open} onClick={toggle}>
      <DrawerHeader onClick={(event) => event.stopPropagation()}>
        <img alt={'GGB'} src={GGBLogoDarkWithoutBg} />
      </DrawerHeader>
      <AppDrawerItems open={open} />
      <DrawerToggle onClick={toggle}>{open ? <ChevronLeftIcon /> : <ChevronRightIcon />}</DrawerToggle>
    </StyledDrawer>
  )
}

const StyledDrawer = styled(Drawer)<Props>`
  flex-shrink: 0;
  white-space: nowrap;
  overflow: visible;
  cursor: pointer;

  & .MuiPaper-root {
    overflow: visible;
    transition: ${(props) => (props.open ? '240ms ease-out' : '140ms ease-out')};
  }

  & > div {
    width: ${(props) => (props.open ? '212px' : '80px')};
  }
`

const DrawerHeader = styled.div`
  display: flex;
  align-items: center;
  margin: 15px;
  height: 64px;
  border-bottom: ${(props) => props.theme.customPalette.lightGray};
`

const DrawerToggle = styled(IconButton)`
  position: absolute;
  top: 50%;
  right: -30px;
  transform: translateY(-50%);
`
